import { SparklesIcon, ZapIcon } from "lucide-react";

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
} from "@/components/ui/select";

type ModelPickerValue = "lite" | "pro";

type ModelOption = {
	value: ModelPickerValue;
	label: string;
	shortLabel: string;
	icon: typeof ZapIcon;
	description: string;
};

const MODEL_OPTIONS: ModelOption[] = [
	{
		value: "lite",
		label: "StudyOS Lite",
		shortLabel: "Lite",
		icon: ZapIcon,
		description: "默认轻量路由",
	},
	{
		value: "pro",
		label: "StudyOS Pro",
		shortLabel: "Pro",
		icon: SparklesIcon,
		description: "默认高阶路由",
	},
];

export type ModelPickerProps = {
	value: string;
	onValueChange: (value: string) => void;
};

export function ModelPicker({ value, onValueChange }: ModelPickerProps) {
	const selectedOption =
		MODEL_OPTIONS.find((option) => option.value === value) ?? MODEL_OPTIONS[0];

	return (
		<Select
			onValueChange={(nextValue) => {
				if (nextValue) {
					onValueChange(nextValue);
				}
			}}
			value={selectedOption.value}
		>
			<SelectTrigger size="sm" className="max-w-[calc(100vw-4rem)]">
				<span className="flex min-w-0 items-center gap-2">
					<selectedOption.icon className="size-4 text-muted-foreground" />
					<span className="truncate">{selectedOption.shortLabel}</span>
				</span>
			</SelectTrigger>
			<SelectContent align="start">
				<SelectGroup>
					{MODEL_OPTIONS.map((option) => (
						<SelectItem key={option.value} value={option.value}>
							<div className="flex min-w-0 items-center gap-2">
								<option.icon className="size-4 text-muted-foreground" />
								<span className="truncate">{option.label}</span>
							</div>
						</SelectItem>
					))}
				</SelectGroup>
			</SelectContent>
		</Select>
	);
}
